import Viewport from './core/Viewport';
import Components from './core/Components';
import lazySizes from './lib/lazysizes';
import EcoMode from './lib/EcoMode';
import FullscreenSlideshow from './lib/FullscreenSlideshow';
import $ from './core/Dom';

document.addEventListener('lazybeforesizes', e => {
    if (EcoMode.getPrefs().ecoMode === 'on') {
        e.detail.width = (e.detail.width / 4) / window.devicePixelRatio;
    }
});

let ticking = false;

const init = () => {
    Viewport.init();
    Viewport.initTabbing();
    EcoMode.init();
    FullscreenSlideshow.init();
    Components.init();
    lazySizes.init();
    
    $('body').on('click', '[data-fullscreen-image-slideshow-trigger]', e => {
        const $trigger = $(e.triggerTarget);
        const uids = $trigger.attr('data-fullscreen-image-slideshow-trigger').split('|');
        
        if (uids.length === 2) {
            FullscreenSlideshow.open(uids[0], uids[1]);
        }
    });

    window.addEventListener('popstate', e => {
        const { state } = e;

        if (state && state.reloadBack) {
            window.location.reload();
        }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    Viewport.on('resize', onResize);
};

const onScroll = () => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            document.documentElement.style.setProperty('--scroll-y', Math.max(0, window.scrollY));
            ticking = false;
        });
        ticking = true;
    }
};

const onResize = () => {
    document.documentElement.style.setProperty('--document-height', document.body.clientHeight);
    document.documentElement.style.setProperty('--viewport-height', window.innerHeight);
};

require('doc-ready')(init);
